/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiDocument
 */
export interface InternalApiDocument {
    /**
     * 
     * @type {number}
     * @memberof InternalApiDocument
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiDocument
     */
    fileName: string;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiDocument
     */
    user: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiDocument
     */
    createdTime: Date;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiDocument
     */
    userDeleted?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiDocument
     */
    deletedTime?: Date;
}

/**
 * Check if a given object implements the InternalApiDocument interface.
 */
export function instanceOfInternalApiDocument(value: object): value is InternalApiDocument {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function InternalApiDocumentFromJSON(json: any): InternalApiDocument {
    return InternalApiDocumentFromJSONTyped(json, false);
}

export function InternalApiDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileName': json['fileName'],
        'user': InternalApiUserBasicDetailsFromJSON(json['user']),
        'createdTime': (new Date(json['createdTime'])),
        'userDeleted': json['userDeleted'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['userDeleted']),
        'deletedTime': json['deletedTime'] == null ? undefined : (new Date(json['deletedTime'])),
    };
}

export function InternalApiDocumentToJSON(json: any): InternalApiDocument {
    return InternalApiDocumentToJSONTyped(json, false);
}

export function InternalApiDocumentToJSONTyped(value?: InternalApiDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileName': value['fileName'],
        'user': InternalApiUserBasicDetailsToJSON(value['user']),
        'createdTime': value['createdTime'].toISOString(),
        'userDeleted': InternalApiUserBasicDetailsToJSON(value['userDeleted']),
        'deletedTime': value['deletedTime'] == null ? value['deletedTime'] : value['deletedTime'].toISOString(),
    };
}

